import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-do-not-sell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './do-not-sell.component.html',
  styleUrl: './do-not-sell.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoNotSellComponent {
  companyName = 'Wall St Yardie Inc';
  companyAddress = '602 N University Dr., Pembroke Pines, FL 33024';
  contactEmail = 'bossman@wallstyardie.com';
  lastUpdated = 'December 2, 2024';
}
